{
  "advancededitor": {
    "Add entry": "Eintrag hinzufügen",
    "Duplicate": "Duplikat",
    "Image attached": "Bild angehängt",
    "Inherit from wheel": "Von Rad erben",
    "Not shown on the wheel": "Nicht auf dem Rad abgebildet",
    "Popup message": "Pop-up-Nachricht",
    "Shown on the wheel": "Auf dem Rad abgebildet",
    "Weight": "Gewicht"
  },
  "app": {
    "Ads": "Anzeigen",
    "Click here to report an inappropriate ad": "Klicken Sie hier, um eine unangemessene Anzeige zu melden.",
    "Click the Language menu": "Klicken Sie auf das Menü oben rechts, um zu Deutsch zu wechseln",
    "Close ad": "Anzeige schließen",
    "Common questions about using the random name picker wheel": "Häufig gestellte Fragen zur Verwendung des zufälligen Namensauswahlrads",
    "Copy this wheel": "Kopiere dieses Rad",
    "Create your own": "Mach dein eigenes",
    "Error": "Fehler",
    "Free and easy to use": "Kostenlos und einfach zu bedienen. Wird von Lehrern und für Gewinnspiele verwendet. Geben Sie Namen ein und drehen Sie das Rad, um einen zufälligen Gewinner auszuwählen. Passen Sie das Erscheinungsbild an, speichern und teilen Sie die Räder.",
    "Frequently Asked Questions": "Häufig gestellte Fragen",
    "It looks like you are using Internet Explorer": "Anscheinend verwenden Sie den Internet Explorer. Dieser Browser wird bald keine Sicherheitsupdates mehr von Microsoft erhalten. Dies setzt Sie und uns einem großen Risiko aus.\nIn Kürze können Sie diese Website nicht mehr mit dem Internet Explorer verwenden. Bitte laden Sie einen anderen Browser herunter, indem Sie online nach \"Webbrowser herunterladen\" suchen. Jeder moderne Browser reicht aus, zum Beispiel Chrome, Firefox oder Edge.",
    "Loaded default names and options": "Beispielnamen und -optionen hinzugefügt",
    "Random name picker": "Zufällige Namensauswahl",
    "Removed": "{name} entfernt",
    "Removing winner in": "Gewinner in {seconds} Sekunden entfernen",
    "Report bad ad": "Schlechte Anzeige melden",
    "Warning": "Warnung",
    "We try to display only legitimate and honest ads": "Wir versuchen, nur legitime und ehrliche Anzeigen zu schalten.",
    "authError": "Das hat nicht funktioniert. Bitte versuchen Sie es erneut und Sie werden aufgefordert, sich anzumelden. Wenn dies immer noch nicht funktioniert, versuchen Sie Folgendes: Aktualisieren Sie die Seite mit Strg + Umschalt + R (Windows, Linux, Chromebook) oder Befehl + Umschalt + R (Mac). Schalten Sie Ihren Werbeblocker und Ihre Antivirensoftware aus."
  },
  "faq": {
    "How do I use this app": "Wie benutze ich diese App",
    "This app lets you spin a wheel": "Mit dieser App können Sie ein Rad drehen",
    "Can I save my wheel": "Kann ich mein Rad speichern",
    "Yes, if you create an account": "Ja, wenn Sie ein Konto erstellen",
    "Is this app free": "Ist diese App kostenlos",
    "Yes, this app is completely free": "Ja, diese App ist völlig kostenlos"
  },
  "appInfo": {
    "Terms of service": "Nutzungsbedingungen",
    "Version": "Ausführung"
  },
  "common": {
    "Cancel": "Abbrechen",
    "Close": "Schließen",
    "Continue": "Fortsetzen",
    "Customize": "Anpassen",
    "Delete": "Löschen",
    "Edit description": "Beschreibung bearbeiten",
    "Edit title": "Titel bearbeiten",
    "Edit title and description": "Titel und Beschreibung bearbeiten",
    "If you dont see a Google login button below": "Wenn Sie unten keine Google-Anmeldeschaltfläche sehen, liegt dies wahrscheinlich daran, dass Sie einen Werbeblocker verwenden, der fälschlicherweise glaubt, die Schaltfläche sei eine Anzeige.",
    "Link Google Account": "Google-Konto verknüpfen",
    "Link Google Sheet": "Google-Tabelle verlinken",
    "Link Google Spreadsheet": "Google-Spreadsheet verlinken",
    "My account": "Mein Konto",
    "OK": "OK",
    "Open": "Öffnen",
    "Privacy policy": "Datenschutz",
    "Report offensive content": "Beleidigende Inhalte melden",
    "Save": "Speichern",
    "Sign in with Google": "Mit Google anmelden",
    "Sign in": "Anmelden",
    "Create account": "Konto erstellen",
    "or": "oder",
    "Email": "E-Mail",
    "Password": "Passwort",
    "Display name": "Anzeigename",
    "Display name is required": "Anzeigename ist erforderlich",
    "Sign in instead": "Stattdessen anmelden",
    "Use this in the classroom": "Verwenden Sie dies im Unterricht",
    "We have a winner!": "Es gibt einen Gewinner!",
    "Wheel description": "Radbeschreibung",
    "Wheel title": "Radtitel",
    "Max": "Max.",
    "Move down": "Nach unten verschieben",
    "Move up": "Nach oben verschieben"
  },
  "nameTabs": {
    "Clear the list": "Löschen Sie die Liste",
    "Entries": "Einträge",
    "Hide": "Verdecken",
    "Results": "Ergebnisse"
  },
  "opendialog": {
    "Are you sure": "Sind Sie sicher, dass Sie \"{wheelTitle}\" löschen möchten? Dies kann nicht rückgängig gemacht werden.",
    "Delete wheel": "Glücksrad löschen",
    "No wheels found": "Es wurden keine Räder in Ihrem Konto gefunden. Versuche ein Rad zu retten!",
    "Open wheel": "Glücksrad öffnen",
    "To open wheels": "Um ein vorhandenes Glücksrad zu öffnen, müssen Sie sich anmelden.\nBitte wählen Sie Ihre Anmeldemethode aus."
  },
  "optionsdialog": {
    "After spin": "Nach dem Drehen",
    "All names in the text-box": "Alle Namen im Textfeld haben unabhängig von diesem Wert die gleichen Gewinnchancen.",
    "Animate winning entry": "Gewinner animieren",
    "Appearance": "Aussehen",
    "Apply a theme": "Farbschema verwenden",
    "Auto-remove winner after 5 seconds": "Gewinner nach 5 Sekunden automatisch entfernen",
    "Background color": "Hintergrundfarbe der Seite",
    "Center text": "Text in der Mitte",
    "Colors": "Farben",
    "Colors tooltip": "Klicken Sie auf die Farbfelder, um sie zu ändern",
    "Contours": "Konturen",
    "Custom": "Benutzerdefiniert",
    "Customize colors": "Farben anpassen",
    "Disabled because the entries": "Deaktiviert, da die Einträge ungleiche Gewichte haben",
    "Display Hide button": "Zeigen Sie die Schaltfläche \"Ausblenden\" an",
    "Display Remove button": "Zeigen Sie die Schaltfläche \"Entfernen\" an",
    "Display duplicates": "Duplikate anzeigen",
    "Display every entry": "Zeigen Sie jeden Eintrag in der Textbox als Eintrag im Rad an, auch Duplikate",
    "Display popup with message:": "Fenster mit Nachricht anzeigen:",
    "During spin": "Während des Drehens",
    "From Gallery": "Galerie",
    "Image": "Bild",
    "Image in the center of the wheel": "Bild in der Mitte des Glücksrads",
    "Image size": "Bildgröße",
    "Launch confetti": "Konfetti werfen",
    "Max names on wheel": "Maximale Anzahl an Namen",
    "No": "Nein",
    "One color": "Eine Farbe pro Abschnitt",
    "Options": "Optionen",
    "Pick category": "Kategorie auswählen",
    "Pick theme": "Farbschema auswählen",
    "Play click sound when the winner is removed": "Spielen Sie einen Klick-Sound, wenn der Gewinner entfernt wird",
    "Remove image": "Bild entfernen",
    "Select a gallery picture": "Wählen Sie ein Galeriebild",
    "Show title": "Titel anzeigen",
    "Sound": "Klingen",
    "Spin slowly": "Langsam drehen",
    "Spin time (seconds)": "Drehzeit",
    "Text": "Text",
    "Upload image": "Bild hochladen",
    "Volume": "Volumen",
    "Wheel background image": "Rad-Hintergrundbild",
    "Yes": "Ja",
    "Your image has been uploaded": "Dein Bild '{fileName}' wurde erfolgreich hochgeladen. Möchten Sie die markanten Farben dieses Bildes für die Bereiche Ihres Rades verwenden?",
    "Advanced mode is enabled": "Der erweiterte Modus ist aktiviert",
    "Sounds": "Töne",
    "Behavior": "Verhalten",
    "Effects": "Effekte",
    "Color": "Farbe"
  },
  "profiledropdown": {
    "Are you sure you want to delete your account": "Sind Sie sicher, dass Sie Ihr Konto und alle Ihre gespeicherten Räder löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.",
    "Delete account": "Konto löschen",
    "Delete my account": "Lösche meinen Konto",
    "Export my data": "Meine Daten exportieren",
    "Sign out": "Abmelden",
    "Signed out": "Abgemeldet",
    "Signed in as": "Angemeldet als {name}",
    "Anonymous user": "Anonymer Benutzer",
    "Welcome new user": "Willkommen bei Spin the Names! Ihr Konto wurde erstellt.",
    "Signed in success": "Erfolgreich angemeldet!",
    "Your account and your saved wheels have been deleted": "Ihr Konto und Ihre gespeicherten Räder wurden gelöscht"
  },
  "savedialog": {
    "Save as": "Speichern als",
    "Save wheel": "Glücksrad speichern",
    "Select a wheel": "Ein Glücksrad auswählen",
    "Sorry, too many images": "Dieses Glücksrad enthält zu viele Bilder. Bitte reduzieren Sie die Anzahl der Bilder und versuchen Sie es nochmal.",
    "To save wheels": "Um ein Glücksrad zu speichern, müssen Sie sich anmelden.\nBitte wählen Sie Ihre Anmeldemethode.",
    "Wheel saved successfully": "Glücksrad \"{wheelTitle}\" wurde erfolgreich gespeichert",
    "You will always be able to access": "Sie können immer auf Ihre gespeicherten Räder zugreifen, solange Sie mindestens alle 12 Monate ein Rad öffnen oder speichern.",
    "Your existing wheels": "Ihre gespeicherten Glücksräder"
  },
  "sharedialog": {
    "Copy link": "Link kopieren",
    "Created": "Erstellt",
    "If you continue": "Wenn Sie fortfahren, erstellen Sie einen öffentlichen Link zu Ihrem aktuellen Rad, einschließlich dessen Namen, Farben und Einstellungen.",
    "Last viewed": "zuletzt angesehen",
    "Link": "Verknüpfung",
    "Link copied to the clipboard": "Der Link wurde in der Zwischenablage gespeichert",
    "Link to this wheel": "Zu diesem Glücksrad mit den aktuellen Namen, Farben und Einstellungen verlinken:",
    "My shared wheels": "Meine geteilten Räder",
    "No wheels found": "In Ihrem Konto wurden keine freigegebenen Räder gefunden. Versuchen Sie, ein Rad zu teilen!",
    "See my shared wheels": "Siehe meine geteilten Räder",
    "Shareable link": "Teilbarer Link",
    "Show title to people": "Zeigen Sie den Titel den Personen an, die Ihren freigegebenen Link verwenden",
    "Sorry, too many images": "Dieses Glücksrad enthält zu viele Bilder. Bitte reduzieren Sie die Anzahl der Bilder und versuchen Sie es nochmal.",
    "They should be able to spin the wheel and": "Sie sollten in der Lage sein, das Rad zu drehen und eine Kopie davon anzufertigen",
    "They should only be able to spin the wheel": "Sie sollten nur das Rad drehen können",
    "This link will work for anyone": "Dieser Link funktioniert für jeden und Sie können ihn per E-Mail, Website, Social Media usw. teilen. Nicht verwendete Links werden nach 365 Tagen gelöscht.",
    "Visits": "Besuche",
    "We want this website to be safe place for everyone": "Wir möchten, dass diese Website ein sicherer Ort für alle ist. Räder, die nicht familienfreundlich sind und gegen die Nutzungsbedingungen verstoßen, werden gelöscht.",
    "What should a person be able to do": "Was sollte eine Person tun können, wenn sie Ihren freigegebenen Link verwendet?"
  },
  "sheetdialog": {
    "Column": "Spalte",
    "First row": "Erste Zeile",
    "Is a header and should not be imported": "ist eine Überschrift und soll ausgeschlossen werden",
    "Link sheet": "Spreadsheet verlinken",
    "Select a column": "Spalte auswählen",
    "Select a tab": "Seitennamen auswählen",
    "Selected spreadsheet": "Ausgewähltes Spreadsheet",
    "Tab": "Seitenname",
    "To import sheets": "Um Spreadsheets zu verbinden, müssen Sie sich mit Ihrem Google Account anmelden. Warum? Google muss wissen, wer Sie sind, damit Sie Ihre Spreadsheets auswählen können.",
    "When you link a spreadsheet": "Wenn Sie eine Google Spreadsheets-Datei verbinden, wird das Glücksrad die dort eingegebenen Daten anzeigen. Wenn Zeilen entfernt oder hinzugefügt werden, werden Sie automatisch ebenfalls auf dem Glücksrad geändert. Die Verbindung wird nach einer Stunde geschlossen.",
    "added": "{entry} hinzugefügt",
    "entries added": "{count} Namen hinzugefügt"
  },
  "sounds": {
    "Alarm clock": "Wecker",
    "Angel choir": "Engelchor",
    "Announcement bell": "Ankündigungsglocke",
    "Applause": "Lauter Applaus",
    "Basketball buzzer": "Basketball-Summer",
    "Bell ringing": "Glockenläuten",
    "Bird chirps": "Vogelgezwitscher",
    "Boing": "Boing",
    "Boing 2": "Boing 2",
    "Carnival shout": "Karnevalsschrei",
    "Cartoon whistle": "Cartoon-Pfeife",
    "Cat meow": "Katze miau",
    "Childrens hooray": "Hurra für Kinder",
    "Cinematic drum impact": "Filmischer Schlagzeugaufprall",
    "Cinematic music": "Filmmusik",
    "Correct answer ding": "Richtige Antwort klingelt",
    "Crash": "Absturz",
    "Cymbals": "Becken",
    "Dog bark": "Hundegebell",
    "Drum roll": "Trommelwirbel",
    "Easy listening": "Einfach zuhören",
    "Evil laugh": "Böses Lachen",
    "Fanfare": "Fanfare",
    "Fireworks": "Feuerwerk",
    "Game win ding": "Spielgewinn ding",
    "Ghost": "Geist",
    "Hooray": "Hurra",
    "Horror scream": "Horrorschrei",
    "Horse": "Pferd",
    "Joke punchline": "Witze Pointe",
    "Lion roar": "Löwengebrüll",
    "Lost game": "Verlorenes Spiel",
    "Microwave ding": "Mikrowelle klingelt",
    "Military trumpet": "Militärtrompete",
    "Mystery bell": "Rätselglocke",
    "No sound": "Keinen Ton",
    "Notification bell": "Benachrichtigungsglocke",
    "Old phone ringing": "Altes Telefon klingelt",
    "Pan flute": "Panflöte",
    "Pop music": "Popmusik",
    "Random 8-Bit": "Zufälliges 8-Bit",
    "Random ballroom dancing": "Zufälliger Gesellschaftstanz",
    "Random cinematic music": "Zufällige Filmmusik",
    "Random dance & techno": "Zufälliger Tanz & Techno",
    "Random disco": "Zufallsdisco",
    "Random easy listening": "Zufälliges Easy Listening",
    "Random electronica": "Zufällige Elektronik",
    "Random folk music": "Zufällige Volksmusik",
    "Random funk": "Zufälliger Funk",
    "Random hip hop": "Zufälliger Hip-Hop",
    "Random music": "Zufällige Musik",
    "Random polka": "Zufällige Polka",
    "Random pop music": "Zufällige Popmusik",
    "Random reggae & reggaeton": "Zufälliger Reggae & Reggaeton",
    "Random retro-rock": "Zufälliger Retro-Rock",
    "Random rock music": "Zufällige Rockmusik",
    "Random rockabilly": "Zufälliger Rockabilly",
    "Random silent film score": "Zufällige Stummfilmmusik",
    "Random winter holidays": "Zufällige Winterurlaubsmusik",
    "Random world music": "Zufällige Weltmusik",
    "Read out the winning name": "Lesen Sie den Gewinnernamen vor",
    "Read out the winning name (option 1)": "Vorlesen des Gewinnernamens (Option 1)",
    "Read out the winning name (option 2)": "Vorlesen des Gewinnernamens (Option 2)",
    "Referee whistle": "Schiedsrichterpfeife",
    "Rock music": "Rockmusik",
    "Sad trombone": "Traurige posaune",
    "Silent film score": "Stummfilmmusik",
    "Sound effects": "Soundeffekte",
    "Subdued applause": "Gedämpfter Applaus",
    "Swoosh ding": "Swoosh Ding",
    "Synth bell": "Synth Glocke",
    "Taiko drum": "Taiko-Trommel",
    "Thunder": "Donner",
    "Ticking sound": "Tickender Ton",
    "Twinkling star": "Funkelnder Stern",
    "Water splash": "Wasserspritzen",
    "Winter holidays": "Winterferienmusik",
    "Wolf howl": "Wolfsgeheul",
    "World music": "Weltmusik",
    "Xylophone ascending": "Xylophon aufsteigend"
  },
  "spinningwheel": {
    "Click to spin": "Zum Drehen klicken",
    "Tap to spin": "zum Drehen tippen",
    "or press ctrl+enter": "oder strg+enter drücken"
  },
  "textboxbuttons": {
    "Add image": "Bild hinzufügen",
    "Advanced": "Erweitert",
    "Revert from advanced": "Zurückkehren",
    "Reverting will reset": "Wenn Sie aus dem erweiterten Modus zurückkehren, können einige Farben verloren gehen. Bist du dir sicher, dass du weitermachen willst?",
    "Shuffle": "Mischen",
    "Sort": "Sortieren"
  },
  "toolbar": {
    "Add your language": "Ihre Sprache hinzufügen",
    "Dark mode": "Dunkler Modus",
    "Exit fullscreen": "Vollbild beenden",
    "FAQ": "FAQ",
    "Feedback": "Feedback",
    "Fullscreen": "Vollbild",
    "Language": "Sprache",
    "More": "Mehr",
    "New": "Neu",
    "Offline mode": "Offlinemodus",
    "Please enter your email address": "Bitte geben Sie Ihre E-Mail-Adresse ein, um fortzufahren",
    "Send debug data": "Debug-Daten senden",
    "Share": "Teilen",
    "System theme": "System-Design",
    "Theme settings": "Design-Einstellungen",
    "Light theme": "Helles Design",
    "Dark theme": "Dunkles Design",
    "Light": "Hell",
    "Dark": "Dunkel",
    "Currently using": "Aktuell verwendet",
    "Theme": "Design",
    "Unlink Google Spreadsheet": "Verlinkung aufheben",
    "User reviews and tutorials": "Benutzerbewertungen und Tutorials",
    "Your session is now being recorded": "Ihre Sitzung wird jetzt aufgezeichnet. Sie können die Aufzeichnung stoppen, indem Sie Ihr Browserfenster schließen."
  },
  "winnerdialog": {
    "Hide": "verbergen",
    "Remove": "Entfernen",
    "Remove all instances": "Alles entfernen"
  },
  "banner": {
    "setupMessage": "Hallo! Wir richten noch alles ein. Einige Funktionen sind möglicherweise eingeschränkt oder vorübergehend nicht verfügbar. Vielen Dank für Ihre Geduld!",
    "dismissLabel": "Ankündigung schließen"
  },
  "accountdialog": {
    "Sign in intro": "Melden Sie sich an, um Ihre Räder zu speichern, zu teilen und zu verwalten.",
    "Preparing sign-in": "Anmeldeoptionen werden vorbereitet…",
    "Troubleshooting title": "Fehlerbehebung bei der Anmeldung",
    "Login failed": "Anmeldung fehlgeschlagen. Bitte versuchen Sie es erneut.",
    "Email verified": "E-Mail bestätigt",
    "Email not verified": "E-Mail nicht bestätigt",
    "Resend verification email": "Bestätigungs-E-Mail erneut senden",
    "Verification email sent": "Bestätigungs-E-Mail gesendet. Prüfen Sie Ihren Posteingang und Spam-Ordner.",
    "Verification email failed": "Senden der Bestätigungs-E-Mail fehlgeschlagen. Bitte versuchen Sie es später erneut."
  }
}
